export default "__VITE_ASSET__mntzyD8Q__"